import { IPaginationOption } from '../../types/pagination';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EPaginationActionTypes {
  SetPageOptions = 'PAGINATION/SET_PAGE_OPTIONS',
}

export const setPageOptions = actionGenerator<EPaginationActionTypes.SetPageOptions, IPaginationOption[]>(
  EPaginationActionTypes.SetPageOptions,
);

export type TPaginationActions = ReturnType<typeof setPageOptions>;
